import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { Link } from 'react-router-dom'
import {
    avatar11,
    avatar12,
    avatar13,
    userProfile,
} from '../../assets/images'
import {
    IconBrandInstagram,
    IconBrandTwitter,
    IconBrandFacebook,
    IconBrandLinkedin,
    IconBrandGoogleFilled,
} from '@tabler/icons-react'

export default function ClientList() {
    return (
        <>
            <Breadcrumb title="Client List" path="Clients / Client List" />
            <div className='grid xxl:grid-cols-4 md:grid-cols-2 md:gap-30 gap-15'>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar11} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        John Smith
                    </p>
                    <small className='mb-5'>
                        CEO
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        vPro Infoweb LLC.
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandFacebook className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar12} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Hossein Shams
                    </p>
                    <small className='mb-5'>
                        CEO
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        BT Technology
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandGoogleFilled className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandLinkedin className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar13} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Maryam Amiri
                    </p>
                    <small className='mb-5'>
                        CEO
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        Core Infoweb Pvt.
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandFacebook className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Tim Hank
                    </p>
                    <small className='mb-5'>
                        CEO
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        AUR Tech LLC.
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandLinkedin className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={userProfile} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        John Smith
                    </p>
                    <small className='mb-5'>
                        Director
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        Lucid Theme Pvt.
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandFacebook className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar13} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Frank Camly
                    </p>
                    <small className='mb-5'>
                        Manager
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        Carlson Software
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandGoogleFilled className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandLinkedin className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar12} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Gary Camara
                    </p>
                    <small className='mb-5'>
                        Marketing Head
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        Fly2 Infotech
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandFacebook className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
                <div className='bg-bg-dark shadow-light rounded-lg md:p-20 p-15 flex flex-col items-center justify-center text-center'>
                    <div className='mb-15'>
                        <img src={avatar11} alt='user' width="90" height="90" className='w-[90px] h-[90px] object-cover rounded-full' />
                    </div>
                    <p className='font-medium text-[20px]/[24px] mb-5'>
                        Tim Hank
                    </p>
                    <small className='mb-5'>
                        Manager
                    </small>
                    <p className='font-medium text-[16px]/[19.2px] mb-15'>
                        Lucid Theme Pvt.
                    </p>
                    <div className='flex gap-5 mb-15'>
                        <button className='btn btn-primary'>
                            View Profile
                        </button>
                        <button className='btn btn-sky'>
                            Message
                        </button>
                    </div>
                    <div className='flex items-center gap-15'>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandLinkedin className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandTwitter className='text-blue w-[18px] h-[18px]' />
                        </Link>
                        <Link to="#" className='rounded-full bg-bg-light-100 p-5'>
                            <IconBrandInstagram className='text-blue w-[18px] h-[18px]' />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}
